import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { GlobalService } from '../global.service';
import { CRMContato } from 'src/app/models/crm/crmcontato';

@Injectable({
  providedIn: 'root'
})
export class CrmcontatoService {

  constructor(private globalService: GlobalService, private http: HttpClient) { }

  consultarContatos() {
    return this.http.get<CRMContato[]>(globals.apiUrl + '/api/CRMContato/Lista');
  }

  consultarContatosComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);
      // .set('franquia', this.globalService.consultaIdDaFranquiaAtual());

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMContato/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdContato(idContato) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMContato/Buscar',
      { params: new HttpParams().set('id', idContato) });
  }

  salvar(contato: CRMContato) {
    return this.http.post(globals.apiUrl + '/api/CRMContato/Salvar', contato);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMContato/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
